import {Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {FormControl, Validators} from '@angular/forms';
import {Contract} from '../../model/Entities/Contract';
import {ContractItemTransfer} from '../../model/Entities/ContractItemTransfer';
import {ContractItemsTransferListComponent} from '../ContractItemsTransferListComponent/contract-items-transfer-list.component';
import {ContractItemsListComponent} from '../ContractItemsListComponent/contract-items-list.component';

@Component({
    selector: "contract-items-transfer-dialog",
    templateUrl: "./contract-items-transfer.dialog.component.html",
    styleUrls: ["./contract-items-transfer.dialog.component.scss"],
})
export class ContractItemsTransferDialogComponent {
    public contract: Contract;
    public direction: any;
    public itemsListComponent: ContractItemsListComponent;
    public isGlobalLoading: boolean = false;

    @ViewChild("itemsTransferList")
    itemsTransferList: ContractItemsTransferListComponent;

    constructor(
        public dialog: MatDialogRef<ContractItemsTransferDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.contract = data.contract;
        this.direction = data.direction;
        this.itemsListComponent = data.itemsListComponent;
    }

    public transferAll(): void {
        this.itemsTransferList.transferAll();
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractItemsTransferDialogComponent/contract-items-transfer.dialog.component.ts